// extracted by mini-css-extract-plugin
module.exports = {"editor":"editor_editor__3Slrd","single_line_editor":"editor_single_line_editor__9Kwk2"};